import { render, staticRenderFns } from "./withdrawal.vue?vue&type=template&id=507640b3"
import script from "./withdrawal.vue?vue&type=script&lang=ts"
export * from "./withdrawal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports